import React from "react";
import { handleDate } from "lib/dates";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useShowMore from "hooks/useShowMore";
import { ContentProps, LinkProps } from "records/Notification";
import { Button, Collapse } from "@alm/flow-ds/components";

interface Props {
	content: ContentProps;
	id: string;
}

function OverdueTaskList({ content, id }: Props) {
	const { t, i18n } = useTranslation();

	// Call hook to handle truncate list
	const { maxLength, showMore, expanded } = useShowMore(
		content.links.length,
		3
	);

	/**
	 * Render links from the content list
	 *
	 * @param start position to start showing from
	 * @param end position to end
	 * @returns
	 */
	const renderLinks = (start: number, end: number) => {
		return content.links
			? content.links.slice(start, end).map((task: LinkProps) => {
					const { link, description, dueDate } = task;
					return (
						<div
							key={link}
							className="notifications__item-info-overdue-list__item">
							<Link to={link}>{description}</Link>
							<div>{handleDate(dueDate, i18n.language, t)}</div>
						</div>
					);
			  })
			: null;
	};

	return (
		<div className="notifications__item-info-overdue-list">
			<div className="notifications__item-info-overdue-list__item notifications__item-info-overdue-list__headings">
				<div>{`${t("main.notifications.overdueTasks")} (${
					content.overdueTaskCount
				})`}</div>
				<div>{t("main.notifications.due")}</div>
			</div>
			{renderLinks(0, maxLength)}
			<Collapse id={`collapse-overdue-${id}`} open={expanded}>
				{renderLinks(maxLength, content.links.length - 1)}
			</Collapse>
			{content.links?.length > maxLength && (
				<Button
					aria-expanded={expanded}
					aria-controls={`collapse-overdue-${id}`}
					label={
						!expanded
							? t("main.labels.showMore")
							: t("main.labels.showLess")
					}
					onClick={showMore}
					className="notifications__item-info-overdue-list__more-less"
				/>
			)}
		</div>
	);
}

export default OverdueTaskList;
